import { Suspense } from 'react';

import { FundingProgressIndicator } from './components/FundingProgressIndicator/FundingProgressIndicator';
import { FundingRequirementsPageLoading } from './components/FundingRequirementsPageLoading/FundingRequirementsPageLoading';
import { DesktopLoanSummary } from './components/LoanSummary/DesktopLoanSummary';
import { MobileLoanSummary } from './components/LoanSummary/MobileLoanSummary';
import { RequirementsHeader } from './components/RequirementsHeader/RequirementsHeader';
import { RequirementsList } from './components/RequirementsList/RequirementsList';
import { useFundingRequirementsParams } from './hooks/useFundingRequirementsParams';
import { useGetFormalOffer } from './hooks/useGetFormalOffer';
import { ErrorBoundary } from '../../../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../../../modals/fallbackErrorModal/FallbackErrorModal';
import { FundingRequirementsPageShell } from '../../components/FundingRequirementsPageShell';

export const FundingRequirementsPage = () => {
    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense fallback={<FundingRequirementsPageLoading />}>
                <FundingRequirementsPageContent />
            </Suspense>
        </ErrorBoundary>
    );
};

const FundingRequirementsPageContent = () => {
    const { offerId, drawdownAmount } = useFundingRequirementsParams();
    const formalOffer = useGetFormalOffer(offerId);

    return (
        <FundingRequirementsPageShell
            sidePanel={
                <DesktopLoanSummary
                    formalOffer={formalOffer}
                    drawdownAmount={drawdownAmount}
                />
            }
            progressIndicator={<FundingProgressIndicator />}
            mainContent={
                <>
                    <div className="min-m:hidden">
                        <MobileLoanSummary
                            formalOffer={formalOffer}
                            drawdownAmount={drawdownAmount}
                        />
                    </div>
                    <div className="mx-auto max-w-[600px] space-y-xl py-2xl">
                        <RequirementsHeader />
                        <RequirementsList />
                    </div>
                </>
            }
        />
    );
};
